"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCreateServicePayload = buildCreateServicePayload;
/*
 * MC&LCC-3.2: one place that turns the service form's data into a create payload.
 *
 * Erik asked the production/bulk configuration screen to be able to create a service without leaving
 * it — "this must be a pop-up with all the data fields and functionality of creating a service". That
 * gave this logic a second caller, and it is a hundred lines of type-conditional field assembly: a
 * POWER service on a municipality supply sends a different shape from an in-house borehole.
 *
 * Copying it would have been the obvious move and the wrong one. Two copies of "which fields does
 * this service type send" drift the moment one ticket touches one of them, and the symptom is a
 * service created from one screen quietly missing fields the other sets.
 */
function buildCreateServicePayload(data, clientId, userId) {
    var isPower = data.serviceType === "POWER";
    var isWater = data.serviceType === "WATER";
    var isInHouse = data.supplySource === "IN_HOUSE";
    return __assign(__assign(__assign(__assign(__assign({ clientId: clientId, buildingId: data.buildingId, name: data.name, serviceType: data.serviceType, serviceCategory: data.serviceCategory, level: data.level || "BUILDING", 
        // GEB-1: only sent for generator services; the API rejects it on any other type.
        consumptionMeteringMethod: data.serviceType === "BACKUP_GENERATOR_POWER" ? data.consumptionMeteringMethod : undefined, supplier: data.supplier, startDate: "".concat(data.startDate, "T00:00:00.000Z"), chartOfAccountCode: data.chartOfAccountCode, notes: data.notes || undefined, createdBy: userId, supplySource: data.supplySource || undefined, financialYearStartMonth: data.financialYearStartMonth ? parseInt(data.financialYearStartMonth, 10) : undefined }, (isPower &&
        data.supplySource === "MUNICIPALITY" && {
        municipalityName: data.municipalityName || undefined,
        nmdKva: data.nmdKva,
        voltageLevel: data.voltageLevel || undefined,
    })), (isPower &&
        data.supplySource !== "MUNICIPALITY" && __assign(__assign({ locality: data.locality || undefined }, (isInHouse && { meterType: data.meterType || undefined })), { transmissionZone: data.transmissionZone || undefined, voltageLevel: data.voltageLevel || undefined, nmdKva: data.nmdKva, phases: data.phases, mainBreakerAPerPhase: data.mainBreakerAPerPhase, isBilledDirectlyByEskom: data.isBilledDirectlyByEskom, hasGridTiedGeneration: data.hasGridTiedGeneration, chargeRateId: data.chargeRateId || undefined }))), (isWater && {
        waterMeterTypes: data.waterMeterTypes || undefined,
    })), (isInHouse && {
        sourceType: data.sourceType || undefined,
        resourceOptions: data.resourceOptions || undefined,
        municipalityName: data.municipalityName || undefined,
        supplierDetails: data.sourceType === "BUILDING" && data.supplierBuildingId && data.supplierServiceId
            ? {
                supplierBuildingId: data.supplierBuildingId,
                supplierServiceId: data.supplierServiceId,
                checkMeter: data.checkMeterId ? { meterId: data.checkMeterId } : undefined,
            }
            : undefined,
        solar: data.solarKwp != null || data.solarKva != null ? { kwpCapacity: data.solarKwp || 0, kvaCapacity: data.solarKva || 0 } : undefined,
        gas: data.gasKwp != null || data.gasKva != null ? { kwpCapacity: data.gasKwp || 0, kvaCapacity: data.gasKva || 0 } : undefined,
        bess: data.bessKwp != null || data.bessKva != null ? { kwpCapacity: data.bessKwp || 0, kvaCapacity: data.bessKva || 0 } : undefined,
        generator: data.generatorCapacity != null ? { capacity: data.generatorCapacity } : undefined,
        boreHole: data.boreHoleNumber
            ? {
                number: data.boreHoleNumber,
                depth: data.boreHoleDepth || 0,
                location: data.boreHoleLocation,
                coordinates: { lat: data.boreHoleLat || 0, lng: data.boreHoleLng || 0 },
            }
            : undefined,
    })), { buildingServiceMeter: data.buildingServiceMeterSerial || data.buildingServiceMeterType
            ? { meterSerialNumber: data.buildingServiceMeterSerial, meterType: data.buildingServiceMeterType }
            : undefined });
}
